import { useAuth } from '@hourly/contexts/AuthContext';
import { useEffect } from 'react';
import { Navigate } from 'react-router';
import Header from '@shared/components/Header';
import Spinner from '@shared/components/Spinner';
import Layout from '../__app/_layout/components/Layout.tsx';
import { useDownload } from './data/hooks/useDownload';
import { useHashParams } from './data/hooks/useHashParams';
import styles from './Download.module.css';

export default function DownloadView() {
  const { isLoggedIn } = useAuth();
  const { filename } = useHashParams<{ filename: string }>();
  const { url } = useDownload(filename);

  useEffect(() => {
    if (url) {
      window.location.href = url;
    }
  }, [url]);

  if (!isLoggedIn) {
    return <Navigate to="/logout" />;
  }

  return (
    <Layout>
      <Layout.Header>
        <Header />
      </Layout.Header>
      <div className={styles.successMessage}>
        {url ? 'Download Complete Successfully' : <Spinner />}
      </div>
    </Layout>
  );
}
